import { Action, handleActions } from 'redux-actions';
import { Immutable, isImmutable } from 'seamless-immutable';
import { IValue } from './actions';

import * as actions from './actions';
import filterHandlerReducer from './filtersHandlerReducer';
import listHandlerReducer from './listHandlerReducer';

type PayloadType = actions.IValue
  & actions.IValue[]
  & { field: string; value: any }
  & { range_start: number; range_end: number; }
  & string
  & { search: string }
  & any;

export default <State extends Immutable<unknown>>(reducerName: string, reducerState: State): any =>
  (prevState: State | any, action: Action<any>): Immutable<unknown> => {
    if (prevState instanceof Function) {
      return reducerState;
    }

    const reducer = handleActions<Immutable<unknown>, PayloadType>(
      {
        ...listHandlerReducer(reducerName),
        ...filterHandlerReducer(reducerName),
        [actions.resetState(reducerName).toString()]: (state) => {
          if (!isImmutable(state)) {
            return state;
          }
          return state.replace(reducerState);
        },
        [actions.setData(reducerName).toString()]: (state, { payload }) => {
          if (!isImmutable(state)) {
            return state;
          }

          if (!payload) {
            return state.merge({
              loaded: true,
              loading: false,
              data: null,
              hasData: false,
            });
          }

          // eslint-disable-next-line react/destructuring-assignment
          return state.merge({
            loaded: true,
            loading: false,
            data: payload.data,
            hasData: payload.hasData, // если у кого то нету - пофиг
          });
        },
        [actions.changePropState(reducerName).toString()]: (state, { payload }) => {
          if (!isImmutable(state) || !payload) {
            return state;
          }
          return state.setIn(payload.path, payload.value);
        },
        [actions.changePropStateMulti(reducerName).toString()]: (state, { payload }: Action<IValue[]>) => {
          if (!isImmutable(state) || !payload) {
            return state;
          }
          let newState = state;
          payload.forEach(({ path, value }) => {
            newState = state.setIn(path as string[], value);
          });
          return newState;
        },
        [actions.openModal(reducerName).toString()]: (state, { payload }) => {
          if (!isImmutable(state) || !payload) {
            return state;
          }
          return state.merge(payload);
        },
        [actions.closeModal(reducerName).toString()]: (state) => {
          if (!isImmutable(state)) {
            return state;
          }
          // eslint-disable-next-line react/destructuring-assignment
          return state.merge({
            modalId: null,
            data: null,
            loading: false,
          });
        },
        [actions.setLoading(reducerName).toString()]: (state) => {
          if (!isImmutable(state)) {
            return state;
          }
          return state.set('loading', true);
        },
        [actions.setLoadingDone(reducerName).toString()]: (state) => {
          if (!isImmutable(state)) {
            return state;
          }
          return state.set('loading', false);
        },
      },
      reducerState,
    );

    return reducer(prevState, action);
  };
